<template>
  <b-sidebar :id="'sidebar-import-recording-' + classroomOrigin.id" title="Sesión desde la que importar" sidebar-class="bb-offcanvas-panel-wrap-no-box full" width="100%"
             v-on:shown="initRecordingImport"
             bg-variant="white" right backdrop-variant="dark" backdrop shadow>
    <template #default="{ hide }">
      <div class="body-content sessions-container">
        <div class="page-controls">
          <div class="page-controls__control-row">
            <div class="page-controls__filter"
                v-bind:class="{'d-none': search_show}">
              <div
                class="dropdown-filter select-wrapper"
              >
                <span class="dropdown-filter__select-label">Por página</span>
                <b-form-select v-on:change="resetPagination" plain class="limit-selector" v-model="classrooms_pagination.limit" :options="classrooms_pagination_options"></b-form-select>
                <span class="dropdown-filter__select-label">Filtrar por</span>
                <b-dropdown id="dropdown-right" right :text="selected_filter" variant=" dropdown-filter__select button button-select dropdown">
                  <b-dropdown-item @click="nextSessions()">Todas las próximas sesiones</b-dropdown-item>
                  <b-dropdown-item @click="pastSessions()">Todas las sesiones anteriores</b-dropdown-item>
                  <b-dropdown-item @click="intervalSessions()">Sesiones en el intervalo</b-dropdown-item>
                </b-dropdown>
                <form
                  class="date-range ng-valid ng-valid-date ng-valid-required ng-dirty ng-valid-parse ng-valid-before-start"
                  v-if="selected_filter==='Sesiones en el intervalo'"
                >
                  <div class="picker-input date">
                    <b-form-datepicker
                      today-button
                      label-today-button="Hoy"
                      reset-button
                      label-reset-button="Limpiar"
                      label-help="Usa las flechas del teclado para navegar entre fechas"
                      label-no-date-selected="-"
                      id="start-date" type="text"
                      v-model="filter_start_date"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="es"
                      @input="getClassrooms()">
                    </b-form-datepicker>
                  </div>
                  <div class="picker-input time">
                    <b-form-timepicker
                      label-close-button="Cerrar"
                      label-no-time-selected="-"
                      id="start-time"
                      v-model="filter_start_time"
                      locale="es"
                      @hidden="getClassrooms()">
                    </b-form-timepicker>
                  </div>
                  <div class="date-range__separator ng-scope">
                    hasta
                  </div>
                  <div class="picker-input date">
                    <b-form-datepicker
                      today-button
                      label-today-button="Hoy"
                      reset-button
                      label-reset-button="Limpiar"
                      label-help="Usa las flechas del teclado para navegar entre fechas"
                      label-no-date-selected="-"
                      id="end-date" type="text"
                      v-model="filter_end_date"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="es"
                      @input="getClassrooms()">
                    </b-form-datepicker>
                  </div>
                  <div class="picker-input time">
                    <b-form-timepicker
                      label-close-button="Cerrar"
                      label-no-time-selected="-"
                      id="end-time"
                      v-model="filter_end_time"
                      locale="es"
                      @hidden="getClassrooms()">
                    </b-form-timepicker>
                  </div>
                </form>
                <b-dropdown id="dropdown-right" right :text="selected_type_filter" variant=" dropdown-filter__select button button-select dropdown">
                  <b-dropdown-item @click="typeSessions('Todos los sistemas')">Todos los sistemas</b-dropdown-item>
                  <b-dropdown-item @click="typeSessions('Collaborate')">Collaborate</b-dropdown-item>
                  <b-dropdown-item @click="typeSessions('Adobe Connect')">Adobe Connect</b-dropdown-item>
                  <b-dropdown-item @click="typeSessions('Zoom')">Zoom</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="page-controls__search ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty"
                v-bind:class="{'page-controls__search--opened': search_show }">
              <div class="dropdown-search" style="padding-top: 9px;">
                <button class="dropdown-search__toggle icon-button align-right " id="tooltip-target-search"
                        v-bind:class="{'d-none': search_show}"
                        @click="showSearch()">
                  <magnify-icon/>
                </button>
                <b-tooltip target="tooltip-target-search" triggers="hover">
                  Buscar clases en directo
                </b-tooltip>
                <div v-if="!opened_search && filter_name" style="display:inline-block;">
                  <p v-text="filter_name" style="color: gray;"></p>
                </div>
                <div class="dropdown-search__dropdown"
                    v-bind:class="{'d-none': !search_show}">
                  <label class="dropdown-search__icon">
                    <span>Buscar clases en directo</span>
                  </label>
                  <input class="dropdown-search__input ng-pristine ng-valid ng-empty ng-touched" type="text"
                        placeholder="Buscar por nombre de la clase"
                        v-model="filter_name">
                  <div class="dropdown-search__controls">
                    <button class="button clear short dropdown-search__control ng-scope"
                            @click="hideSearch()">Cerrar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="full-width-content--small" v-show="!loading">
          <div v-if="!classrooms.length" class="no-content no-results">
            <span class="no-content-title">No encontramos clases que coincidan con esos criterios.</span>
          </div>
          <table v-else class="content-table">
            <tbody>
            <tr class="content-table__header content-table__header--shadow">
              <th class="medium-8">Sala</th>
              <th class="medium-4">Hora de inicio</th>
              <th class="medium-4">Hora de finalización</th>
              <th class="medium-4">Estado</th>
            </tr>
            <tr v-for="classroom in classrooms" v-bind:key="classroom.id" class="element-list-row">
              <td class="break-word content-table__emphasis">
                <span class="inline-column-title ng-scope">Sala:</span>
                <bdi>{{ classroom.name }}</bdi><br/>
                <span class="description" v-html="classroom.description"></span>
              </td>
              <td class="date">
                <span class="date">
                  {{ classroom.start | moment("D/M/YY HH:mm") }}
                </span>
              </td>
              <td class="date">
                <span class="date">
                  {{ classroom.end | moment("D/M/YY HH:mm") }}
                </span>
              </td>
              <td class="status">
                <span class="status">
                  <span v-if="isOngoing(classroom)">
                    En progreso
                  </span>
                  <span v-if="!isOngoing(classroom)">
                    <span class="session-not-started" v-if="notYetStarted(classroom) && classroom.end">
                      Aún no ha comenzado
                    </span>
                    <span class="session-not-started" v-if="notYetStarted(classroom) && !classroom.end">
                      Aún no ha comenzado
                    </span>
                    <span class="session-not-started" v-if="hasEnded(classroom)">
                      <span class="session-ended">
                        Finalizado
                      </span>
                    </span>
                  </span>
                </span>
              </td>
              <td class="item-controls" style="text-align: unset;">
                <button class="button secondary short button-action-reuse-session" v-b-toggle.sidebar-no-header="'sidebar-import-recording-sesion-' + classroom.id"
                @click="reuseSessionRecording(classroom)">{{ $t("sessions.reusemodal.reuse") }}</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <footer v-if="classrooms_pagination.limit < classrooms_total" class="page-footer session-list-pagination">
        <b-pagination
          v-model="classrooms_pagination_current"
          :total-rows="classrooms_total"
          :per-page="classrooms_pagination.limit"
          align="center"
          aria-controls="report-content-table"
        ></b-pagination>
      </footer>
      <ImportRecordingSesionsRecordingsSidebar
        :classroomOrigin="classroomOrigin"
        :reuseClassroom="reuseClassroom">
      </ImportRecordingSesionsRecordingsSidebar>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import LocationEnterIcon from 'vue-material-design-icons/LocationEnter.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import { minLength, required, numeric, url } from 'vuelidate/lib/validators'
import KeyboardReturnIcon from 'vue-material-design-icons/KeyboardReturn.vue'
import CloudDownloadOutlineIcon from 'vue-material-design-icons/CloudDownloadOutline.vue'
import jwtMixin from '../../../mixins/jwtMixin'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'
import DotsHorizontalCircleOutlineIcon from 'vue-material-design-icons/DotsHorizontalCircleOutline.vue'
import CalendarBlankOutlineIcon from 'vue-material-design-icons/CalendarBlankOutline.vue'
import PhoneOutgoingOutlineIcon from 'vue-material-design-icons/PhoneOutgoingOutline.vue'
import LoginIcon from 'vue-material-design-icons/Login.vue'
import TextBoxSearchOutlineIcon from 'vue-material-design-icons/TextBoxSearchOutline.vue'
import PencilOutlineIcon from 'vue-material-design-icons/PencilOutline.vue'
import DeleteOutlineIcon from 'vue-material-design-icons/DeleteOutline.vue'
import DownloadOutlineIcon from 'vue-material-design-icons/DownloadOutline.vue'
import VideoOutlineIcon from 'vue-material-design-icons/VideoOutline.vue'
import Header from '@/components/Admin/Header/Header'
import ImportRecordingSesionsRecordingsSidebar from './ImportRecordingSesionsRecordingsSidebar'

export default {
  name: 'ImportRecordingSesionsSidebar',
  components: {CloseIcon, LocationEnterIcon, KeyboardReturnIcon, CloudDownloadOutlineIcon, MagnifyIcon, Header, DotsHorizontalCircleOutlineIcon, CalendarBlankOutlineIcon, PhoneOutgoingOutlineIcon, LoginIcon, TextBoxSearchOutlineIcon, PencilOutlineIcon, DeleteOutlineIcon, DownloadOutlineIcon, VideoOutlineIcon, ImportRecordingSesionsRecordingsSidebar},
  mixins: [utilitiesMixin, jwtMixin],
  props: ['classroomOrigin'],
  mounted () {
    this.$moment.locale('es')
  },
  created () {
    this.$i18n.locale = this.jwtLanguage()
  },
  data () {
    return {
      loading: false,
      user_groups: [],
      user_roles: [],
      classrooms: [],
      classrooms_total: 0,
      classrooms_pagination_current: 1,
      classrooms_pagination: {
        limit: this.defaultPagination(),
        offset: 0
      },
      classrooms_pagination_options: this.paginationOptions(),
      selected_filter: 'Todas las próximas sesiones',
      selected_type_filter: 'Todos los sistemas',
      search_show: false,
      filter_start_date: null,
      filter_start_time: null,
      filter_end_date: null,
      filter_end_time: null,
      filter_name: null,
      waiting_filter_name: false,
      context_title: null,
      opened_search: false,
      reuseClassroom: null
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    },
    duration: {
      required,
      numeric
    },
    url: {
      required,
      url
    }
  },
  watch: {
    classrooms_pagination_current: {
      handler: function (value) {
        // CMM: se establece la paginación acorde a la página activada
        this.classrooms_pagination.offset = this.classrooms_pagination.limit * (this.classrooms_pagination_current - 1)
        this.getClassrooms()
      }
    },
    filter_name: function (val) {
      let vueComponent = this
      if (!this.waiting_filter_name) {
        setTimeout(() => {
          vueComponent.loading = true
          vueComponent.resetPagination()
          this.waiting_filter_name = false
        }, 1500)
      }
      this.waiting_filter_name = true
    }
  },
  methods: {
    initClassrooms () {
      this.loading = true

      // CMM: Por defecto en la entrada se cargan las próximas sesiones
      this.nextSessions()
    },
    getClassrooms () {
      let vueComponent = this
      this.classrooms = []
      this.classrooms_total = 0
      let filterParams = {
        limit: this.classrooms_pagination.limit,
        offset: this.classrooms_pagination.offset
      }
      // CMM: Configuración de filtros
      if (vueComponent.filter_start_date) {
        if (!this.filter_start_time) {
          this.filter_start_time = '00:00'
        }
        filterParams.startTime = window.moment(vueComponent.filter_start_date + ' ' + this.filter_start_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      } else {
        vueComponent.filter_start_time = null
      }
      if (vueComponent.filter_end_date) {
        if (!this.filter_end_time) {
          this.filter_end_time = '23:59'
        }
        filterParams.endTime = window.moment(vueComponent.filter_end_date + ' ' + this.filter_end_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      } else {
        vueComponent.filter_end_time = null
      }
      if (vueComponent.selected_type_filter) {
        if (vueComponent.selected_type_filter === 'Collaborate') {
          filterParams.targetSystem = 'COLLAB'
        } if (vueComponent.selected_type_filter === 'Adobe Connect') {
          filterParams.targetSystem = 'CONNECT'
        } if (vueComponent.selected_type_filter === 'Zoom') {
          filterParams.targetSystem = 'ZOOM'
        }
      }
      if (this.filter_name) {
        filterParams.name = this.filter_name
      }
      filterParams.targetStatus = '1'
      window.axios.get('classrooms/', {params: filterParams}).then((response) => {
        // CMM: Se recupera la información de las clases, sin enrollment del usuario (modo consulta)
        this.classrooms_total = response.data.size
        response.data.results.forEach(function (classroom) {
          vueComponent.classrooms.push(classroom)
        })
        this.loading = false
      })
    },
    resetPagination () {
      // CMM: Si no estaba en la páginia inicial se cambia a la primera. El cambio lanza la recarga del listado
      if (this.classrooms_pagination_current !== 1) {
        this.classrooms_pagination_current = 1
      } else {
        this.getClassrooms()
      }
    },
    nextSessions () {
      this.selected_filter = 'Todas las próximas sesiones'
      this.filter_start_date = window.moment().format('YYYY-MM-DD')
      this.filter_start_time = window.moment().format('HH:mm')
      this.filter_end_date = null
      this.filter_end_time = null
      this.resetPagination()
    },
    pastSessions () {
      this.selected_filter = 'Todas las sesiones anteriores'
      this.filter_start_date = null
      this.filter_start_time = null
      this.filter_end_date = window.moment().format('YYYY-MM-DD')
      this.filter_end_time = window.moment().format('HH:mm')
      this.resetPagination()
    },
    intervalSessions () {
      this.selected_filter = 'Sesiones en el intervalo'
      this.filter_start_date = window.moment().format('YYYY-MM-DD')
      this.filter_start_time = '00:00'
      this.filter_end_date = window.moment().format('YYYY-MM-DD')
      this.filter_end_time = '23:59'
      this.resetPagination()
    },
    typeSessions (type) {
      this.selected_type_filter = type
      this.resetPagination()
    },
    dispatchShowReportEvent (classroomId) {
      window.EventBus.$emit('show-report', classroomId)
    },
    hideSearch () {
      this.search_show = false
      this.waiting_filter_name = false
      this.opened_search = false
    },
    showSearch () {
      this.search_show = true
      this.opened_search = true
    },
    reuseSessionRecording (classroom) {
      this.reuseClassroom = classroom
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Modals/ImportRecordingSesionsSidebar.vue